import { render, staticRenderFns } from "./bao-cao-xe-hang.vue?vue&type=template&id=6e1ecd8a&"
import script from "./bao-cao-xe-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-xe-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports